import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import ThongkephuongtienGT from "components/Thongke/Phuongtiengiaothong/ThongkephuongtienGT.js";
export default function TKphuongtienGT() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "TK phương tiện giao thông đường bộ",
            tabContent: <ThongkephuongtienGT />,
          },
        ]}
      />
    </div>
  );
}
